import {Component, Prop, Vue} from 'vue-facing-decorator';
import {type Component as VueComponent} from 'vue';
import {namespace} from 'vuex-facing-decorator';
import FormRow from '../components/form/FormRow.vue';
import {getVueParent} from '@/library/dom';

const FormStore = namespace('form');

@Component({
    name: 'AbstractFormInput',
})
export class AbstractFormInput extends Vue
{
    @Prop({
        type: String,
    }) id: string;

    @Prop({
        type: String,
    }) name: string;

    @Prop({
        type: Boolean,
        default: false,
        required: false,
    }) required: boolean;

    @Prop({
        type: Boolean,
        default: false,
        required: false,
    }) overwriteRequired: boolean;

    @Prop({
        type: String,
        default: '',
        required: false,
    }) errorName: string;

    @Prop({
        type: String,
        default: '',
        required: false,
    }) filterName: string;

    @FormStore.State('errors') formErrors: Record<string, string[]>;

    @FormStore.State('submitted') formSubmitted: boolean;

    @FormStore.State('validated') formValidated: FormStateValidated;

    isFormField: boolean = true;

    get _id()
    {
        //@ts-ignore:2339 (vue)
        return this.id || this.formRow?.labelFor || null;
    }

    get _required()
    {
        //@ts-ignore:2339 (vue)
        return this.required || !this.overwriteRequired && this.formRow?._required || false;
    }

    get isInvalid()
    {
        //@ts-ignore:2339 (vue)
        let errorName = this.errorName || this.formRow?._errorName || '';
        if (!errorName)
        {
            return null;
        }

        if (!this.formSubmitted && !this.formValidated[errorName])
        {
            return null;
        }

        return typeof this.formErrors[errorName] !== 'undefined';
    }

    get ariaValidationAttributes()
    {
        //@ts-ignore:2339 (vue)
        if (!this.formRow || this.formRow.isInvalid)
        {
            return {};
        }

        return {
            'aria-invalid': true,
            //@ts-ignore:2339 (vue)
            'aria-descibedby': this.formRow.formErrorId,
        };
    }

    get formRow(): Nullable<typeof FormRow>
    {
        let formRow: Nullable<VueComponent | typeof FormRow> = this.$parent;

        return formRow?.componentName === 'FormRow' ? <typeof FormRow>formRow : null;
    }

    validateValue(newValue: InputValueTypes, context = {}): Promise<any>
    {
        let formRow    = getVueParent(this, 'FormRow') as Nullable<typeof FormRow>;
        //@ts-ignore:2339 (vue)
        let errorName  = this.errorName || formRow?._errorName || '';
        //@ts-ignore:2339 (vue)
        let filterName = this.filterName || formRow?._filterName || errorName;

        if (errorName && filterName)
        {
            // TODO this creates problems if there are backend errors but no frontend errors (backend errors are deleted, but form is still invalid)
            // TODO see formsetps in enrolment (empty url in instagram social share network entry)
            this.$store.commit('form/resetErrors', errorName);

            return this.$store.dispatch('form/validate', {
                value: newValue,
                context: context,
                errorName,
                filterName,
            });
        }

        return Promise.resolve();
    }

    triggerFocus(): void
    {
        this.$el?.focus();
    }
}

export default AbstractFormInput;